/**
 * Favicon conforme o tema do navegador
 *
 * Tema escuro do navegador/sistema: favicon branco; tema claro: roxo (padrão).
 * O index.html já declara os dois ícones com `media` (Chrome e Firefox trocam
 * sozinhos); este script cobre os demais navegadores e a troca com a aba aberta.
 *
 * @author Equipe VendeAi
 * @since 1.3.0
 */

const LIGHT_ICON = '/favicon.png';
const DARK_ICON = '/favicon-dark.png';

export function setupThemeFavicon(): void {
  if (typeof window === 'undefined' || !window.matchMedia) return;
  const query = window.matchMedia('(prefers-color-scheme: dark)');

  const update = () => {
    const href = query.matches ? DARK_ICON : LIGHT_ICON;
    // Um único ícone ativo, sem "media", para o navegador não manter o anterior
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]').forEach(link => {
      if (link.dataset.themeFavicon !== 'active') link.remove();
    });
    let link = document.querySelector<HTMLLinkElement>('link[data-theme-favicon="active"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.dataset.themeFavicon = 'active';
      document.head.appendChild(link);
    }
    if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  };

  update();
  query.addEventListener?.('change', update);
}
